/**
 * React Query 캐시 영속화 persister (단순캐시 / 옵션2 PoC)
 *
 * ISSUE_167: 오프라인 읽기를 위해 React Query 캐시를 IndexedDB(idb-keyval)에 영속.
 * 부팅 시 hydrate → 즉시 캐시 히트(Dexie readThroughCache 의 "IndexedDB 우선" 효과 대체).
 *
 * 영속 대상은 students 쿼리만 (PersistQueryClientProvider 의 dehydrateOptions 로 필터).
 *
 * @module db/persist/queryPersister
 */

import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { get, set, del } from "idb-keyval";

/** idb-keyval 을 React Query AsyncStorage 인터페이스로 어댑트 */
export const queryPersister = createAsyncStoragePersister({
  storage: {
    getItem: (key: string) => get<string>(key).then((v) => v ?? null),
    setItem: (key: string, value: string) => set(key, value),
    removeItem: (key: string) => del(key),
  },
  key: "noten-rq-cache",
  // 직렬화 실패 시 캐시 폐기(앱 동작 우선)
  throttleTime: 1000,
});
